import React from 'react';
import { MDText } from 'i18n-react';

import { BookmarkIcon, EnvelopeIcon, MagnifyingGlassIcon } from '@motorway/motorway-storybook-cra';

import savedSearchesTexts from 'Components/Manage/SavedSearches/SavedSearches.texts';
import SavedSearchIntroStep from 'Components/Manage/SavedSearches/SavedSearchesIntroStep/SavedSearchesIntroStep';

import styles from './SavedSearchesIntroStepList.module.scss';

const LocalT = new MDText(savedSearchesTexts);

const howToSteps = 'empty.steps';

const STEPS = {
	RECEIVE_ALERTS: 'receiveAlerts',
	SAVE_SEARCH: 'saveSearch',
	SET_FILTERS: 'setFilters',
};

const config = {
	[STEPS.SET_FILTERS]: {
		icon: <MagnifyingGlassIcon className={styles.magnifyingGlass} />,
		textPath: `${howToSteps}.setFilters`,
	},
	[STEPS.SAVE_SEARCH]: {
		icon: <BookmarkIcon />,
		textPath: `${howToSteps}.saveSearch`,
	},
	[STEPS.RECEIVE_ALERTS]: {
		icon: <EnvelopeIcon />,
		textPath: `${howToSteps}.receiveAlerts`,
	},
};

const configOrder = [STEPS.SET_FILTERS, STEPS.SAVE_SEARCH, STEPS.RECEIVE_ALERTS];

const SavedSearchesIntroStepList: React.FC = () => (
	<ul className={styles.steps}>
		{configOrder.map((value) => (
			<SavedSearchIntroStep
				key={value}
				body={LocalT.translate(`${config[value].textPath}.body`)}
				icon={config[value].icon}
				title={LocalT.translate(`${config[value].textPath}.title`)}
			/>
		))}
	</ul>
);

export default SavedSearchesIntroStepList;
